export default "__VITE_ASSET__aaa54823__"